import { render, staticRenderFns } from "./WidgetPurple.vue?vue&type=template&id=7264bfda"
import script from "./WidgetPurple.vue?vue&type=script&lang=js"
export * from "./WidgetPurple.vue?vue&type=script&lang=js"
import style0 from "./WidgetPurple.vue?vue&type=style&index=0&id=7264bfda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports